// Fiók-domainek — a normalizálás és a szabad szöveg bontása EGY helyen: az ETL (legacy `other_domains`), a BFF
// (a „Domainek" szekció felvétele/szerkesztése) és az átviteli szkript ugyanazzal a szabállyal dolgozik. Ha a három
// különbözne, ugyanaz a domain kétféle alakban ülne a táblában, és a fiókon belüli egyediség (Odin
// `account_domains_live_uq`) nem fogná meg a duplikátumot.
/** A domain ÁLLAPOTA — az Odin registry-séma enumjával (`clients/account-domains`) egyező értékkészlet. */
export const ACCOUNT_DOMAIN_STATUSES = ['active', 'setup', 'inactive'];
/** A normalizált domain felső hossz-korlátja (DNS: 253 karakter). */
export const ACCOUNT_DOMAIN_MAX_LENGTH = 253;
/**
 * Egy nyers token → normalizált domain vagy elutasítás okkal.
 * Normalizálás: trim + körülvevő írásjelek levágása → kisbetű → séma (http(s)://…) levágása →
 * út/query/fragment/port levágása → domain-alak ellenőrzés (utolsó label = TLD: csak betű, min. 2).
 */
export function normalizeDomainToken(raw) {
    let s = raw.trim();
    // Körülvevő írásjelek (zárójel, idézőjel, vessző, kettőspont, kötőjel-felsorolásjel, pont) levágása.
    s = s.replace(/^[\s"'“”(),;:<>[\]-]+/, '').replace(/[\s"'“”(),;:<>[\].]+$/, '');
    if (s === '')
        return { reason: 'üres a normalizálás után' };
    s = s.toLowerCase();
    // URL-séma levágása (http://, https://, esetleg más séma).
    s = s.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
    // Út / query / fragment levágása, majd port levágása.
    s = s.replace(/[/?#].*$/, '');
    s = s.replace(/:\d*$/, '');
    s = s.replace(/\.+$/, ''); // záró pont(ok)
    if (s === '')
        return { reason: 'üres a normalizálás után' };
    // Domain-alak: label-ek (betű/szám + kötőjel, nem kötőjellel kezdődik/végződik) + betű-TLD (min. 2). A betű
    // UNICODE-betű is lehet: a magyar ékezetes (IDN) domain valódi (mérve a legacy szövegben: `tisiaétterem.hu`),
    // és a felhasználó is így írja be — punycode-ot senki nem gépel.
    const domainRe = /^(?:[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?\.)+\p{L}{2,}$/u;
    if (!domainRe.test(s) || s.length > ACCOUNT_DOMAIN_MAX_LENGTH) {
        return { reason: `nem domain-alakú ("${s}")` };
    }
    return { domain: s };
}
/**
 * A domain ÖSSZEHASONLÍTÁSI kulcsa: a kanonikus ASCII (punycode) alak. Az ékezetes domain és a punycode-alakja
 * (`tisiaétterem.hu` ↔ `xn--tisiatterem-…`) UGYANAZ a domain — a duplikátum-ellenőrzés ezen hasonlít, különben a
 * kettő két külön sorként felvehető volna. A TÁROLT és megjelenített alak marad a normalizált (olvasható) forma.
 * A `URL` mindkét futtatókörnyezetben (Node · böngésző) elérhető; értelmezhetetlen bemenetre a bemenet maga.
 */
export function domainKey(domain) {
    try {
        return new URL(`https://${domain}`).hostname;
    }
    catch {
        return domain;
    }
}
/**
 * Szabad szöveg (a legacy „Egyéb domainek" mező) → nyers tokenek: vessző, pontosvessző, szóköz és sortörés mentén.
 * A tokeneket a hívó normalizálja (`normalizeDomainToken`) — a nem domain-alakú darab (pl. egy CMS-ID-megjegyzés
 * „- 340") ott esik ki, okkal.
 */
export function splitDomainText(text) {
    return text.split(/[\s,;]+/).filter((t) => t !== '');
}
//# sourceMappingURL=account-domains.js.map